// extracted by mini-css-extract-plugin
module.exports = {"heading":"item-list__heading___1YZSE"};